import React from 'react';
import { buildTrialSourceUrl, toPatientFriendlyStatus } from '../utils/trialHelpers';

export default function TrialCard({ trial, onViewDetails, onToggleSave, onOpenMaps, mode = 'list' }) {
  const statusColor =
    trial.recruitingStatus === 'recruiting'
      ? { bg: 'var(--brand-accent-light)', color: 'var(--brand-accent)' }
      : trial.recruitingStatus === 'not_yet_recruiting'
      ? { bg: '#fef3c7', color: '#92400e' }
      : trial.recruitingStatus === 'completed'
      ? { bg: '#e5e7eb', color: '#374151' }
      : { bg: '#e0f2fe', color: '#0c4a6e' };

  return (
    <article
      style={{
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: mode === 'location' ? '13px' : '15px',
        boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'flex-start' }}>
        <div style={{ minWidth: 0 }}>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#0f172a', lineHeight: 1.35 }}>{trial.title}</h3>
          <p style={{ margin: '6px 0 0', color: '#475569', fontSize: '13px', lineHeight: 1.5 }}>{trial.summary}</p>
        </div>
        {trial.isMatched && (
          <span
            style={{
              flexShrink: 0,
              fontSize: '11px',
              fontWeight: '700',
              borderRadius: '999px',
              padding: '4px 9px',
              background: 'var(--brand-accent-light)',
              color: 'var(--brand-accent)',
              border: '1px solid var(--brand-accent-border)',
            }}
          >
            Relevant to you
          </span>
        )}
      </div>

      <div style={{ marginTop: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        <InfoCell label="Institution" value={trial.institution} />
        <InfoCell label="Location" value={`${trial.city}, ${trial.region}, ${trial.country}`} />
        <InfoCell label="Cancer" value={trial.cancerType} />
        <InfoCell label="Stage" value={trial.stage} />
        <InfoCell label="Subtype" value={trial.subtype || 'General'} />
        <InfoCell label="Phase" value={trial.phase || 'N/A'} />
      </div>

      <div style={{ marginTop: '10px', display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span
          style={{
            fontSize: '11px',
            fontWeight: '700',
            borderRadius: '999px',
            padding: '4px 9px',
            background: statusColor.bg,
            color: statusColor.color,
          }}
        >
          {toPatientFriendlyStatus(trial.recruitingStatus)}
        </span>
        {Array.isArray(trial.biomarkers) && trial.biomarkers.length > 0 && (
          <span style={{ fontSize: '12px', color: '#475569' }}>
            Biomarkers: {trial.biomarkers.join(', ')}
          </span>
        )}
      </div>

      <p style={{ margin: '10px 0 0', fontSize: '13px', color: '#334155', lineHeight: 1.45 }}>
        <strong>Eligibility:</strong> {trial.eligibilitySummary}
      </p>

      <div style={{ marginTop: '12px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        <button type="button" onClick={() => onViewDetails(trial)} style={actionPrimaryBtn}>
          View Details
        </button>
        <button type="button" onClick={() => onToggleSave(trial)} style={actionGhostBtn}>
          {trial.isSaved ? 'Unsave Trial' : 'Save Trial'}
        </button>
        <button type="button" onClick={() => onOpenMaps(trial)} style={actionGhostBtn}>
          Open in Maps
        </button>
        <button
          type="button"
          onClick={() => window.open(buildTrialSourceUrl(trial), '_blank', 'noopener,noreferrer')}
          style={actionGhostBtn}
        >
          Find More
        </button>
      </div>
    </article>
  );
}

function InfoCell({ label, value }) {
  return (
    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '8px' }}>
      <div style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>{label}</div>
      <div style={{ marginTop: '2px', fontSize: '12px', color: '#0f172a' }}>{value}</div>
    </div>
  );
}

const actionPrimaryBtn = {
  border: 'none',
  borderRadius: '8px',
  background: 'var(--teal)',
  color: 'white',
  fontSize: '12px',
  fontWeight: '700',
  padding: '8px 10px',
  cursor: 'pointer',
};

const actionGhostBtn = {
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  background: 'white',
  color: '#334155',
  fontSize: '12px',
  fontWeight: '700',
  padding: '8px 10px',
  cursor: 'pointer',
};
